import { createContext, useContext } from 'react'
import type { PayPalScriptOptions } from '@paypal/paypal-js/types/script-options'
import config from 'src/config'

export interface PayPalRuntime {
  status: 'loading' | 'ready' | 'error'
  options: PayPalScriptOptions
  clientId: string
  applePay: boolean
}

export const PayPalRuntimeContext = createContext<PayPalRuntime | null>(null)
export const usePayPalConfiguration = (): PayPalRuntime => useContext(PayPalRuntimeContext) || {
  status: 'ready', options: config.paypalConfig,
  clientId: String(config.paypalConfig?.['client-id'] || ''),
  applePay: config.PayPalApplePayDisplay,
}
